import { useMemo } from "react";
import { Polygon } from "react-leaflet";
import { useSelector } from "react-redux";

import mapStateToProps from "./mapStateToProps"; 

const MapGeozones=()=>{
    const {
        geozoneArr,
        geozoneSettingsArr,
    } = useSelector(mapStateToProps)

    const outedArr = useMemo(()=>{
        if(!geozoneSettingsArr?.length) return null
        return geozoneArr.filter((item, i)=>(geozoneSettingsArr[i].active && item.polygon && item.polygon.length > 2))
    }, [geozoneArr, geozoneSettingsArr])
    
    if(!geozoneSettingsArr || !geozoneSettingsArr.length) return null
    return (
        <>
            {outedArr?.length?outedArr.map(({polygon, color}, index)=>{
                return (<Polygon key={index} pathOptions={{ color, fill:true, fillOpacity:.5 }} positions={polygon.map(({x,y})=>[x,y])} />)
            }):null}
        </>
    )
}

export default MapGeozones